/* eslint-disable arrow-body-style */
/* eslint-disable react/self-closing-comp */
import React, { FC, useEffect, useRef } from 'react';
import { LoadingSpinner } from '@abyss/web/ui/LoadingSpinner';

interface Props {
  id: string;
  loading: boolean;
  moreToLoad: boolean;
  setInfiniteScrollElement: (element: HTMLDivElement) => void;
}

export const InfiniteScrollLoadTrigger: FC<Props> = ({
  id,
  loading,
  moreToLoad,
  setInfiniteScrollElement,
}) => {
  const key = `${id}LoadingMore`;
  const ref = useRef(document.createElement('div'));
  useEffect(() => {
    setInfiniteScrollElement(ref.current);
  }, [ref, ref.current]);

  if (loading) {
    return (
      <div
        data-cy={key}
        data-testid={key}
        key={key}
        className="infiniteScrollLoadingMore"
      >
        <div data-testid="loading">
          <LoadingSpinner
            size="$lg"
            ariaLoadingLabel="Loading more results, please wait"
            isLoading
          />
        </div>
        <div className="infiniteScrollLoadingMoreLabel">Please wait</div>
      </div>
    );
  }

  if (moreToLoad) {
    return <div data-testid="triggering" key="triggering" ref={ref}></div>;
  }

  return <div data-testid="not-triggering"></div>;
};
